import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  LinearProgress,
  SelectChangeEvent,
} from '@mui/material';
import './TankSelect.css';
import { StorageUnit } from './embryoCulture.helpers';
import { RequiredLabel } from '../../../utils/commonUtils';

interface TankSelectProps {
  tanks: StorageUnit[];
  selectedTank: number | null;
  onChange: (value: string) => void;
  label?: string;
  hasError?: boolean;
}

const TankSelect: React.FC<TankSelectProps> = ({
  tanks,
  selectedTank,
  onChange,
  label = 'Tank',
  hasError = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const tankId = event.target.value;
    // eslint-disable-next-line no-console
    console.log('Selected Tank ID:', tankId);
    onChange(tankId);
  };

  const { t: tCulture } = useTranslation('culture_config');

  return (
    <FormControl fullWidth className="tank-select-container" error={hasError} >        

      <InputLabel shrink={selectedTank !== null}>{label}</InputLabel>
      <Select
        value={selectedTank !== null ? String(selectedTank) : ''}
        onChange={handleChange}        
        label={RequiredLabel(label, true)}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200, // Restricts the height of the dropdown
              overflowY: 'auto', // Enables vertical scrolling
            },
          },
        }}
        sx={{
          height: '52px',
        }}
      >
        {tanks.length ? (
          tanks.map((tank) => (
            <MenuItem key={tank.id} value={tank.id} disabled={Number(tank.occupancy) === 100}>
              <Box className="tank-item">
                <Typography className="tank-item-header" sx={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 700,
                  fontSize: '12px',
                }}>
                  {tank.root_name}
                  <span className="tank-progress-text">{tank.occupancy?.toFixed(2) ?? '0.00'}%</span>
                </Typography>
                <Box className="progress-bar-container">
                  <LinearProgress
                    variant="determinate"
                    value={tank?.occupancy !== null ? tank?.occupancy : undefined}
                    className="progress-bar"
                    sx={{
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: Number(tank.occupancy) === 100 ? '#FF0000' : '#68B62B'
                      },
                    }}
                  />
                </Box>
              </Box>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>{tCulture('noTanksAvailable', { defaultValue: 'No tanks available' })}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default TankSelect;
